const func = $target => {
    var $alert = $target;

    $alert.delay(3000).fadeOut();   
};

export default func;